export const COUPON_STATE = Object.freeze({
    UNDETERMINED: 'UNDETERMINED',
    VALIDATING: 'VALIDATING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
});

export const isSuccesfulCoupon = (state) => state === COUPON_STATE.SUCCESS;
export const isFailedCoupon = (state) => state === COUPON_STATE.FAILED;